module.exports = __webpack_public_path__ + "static/media/network-icon.89f56a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/network-icon.png
// module id = 1079
// module chunks = 0